import { createRouter, createWebHistory } from "vue-router";
import store from "../store/index.js";

const routes = [
  {
    path: "/loginOPS",
    name: "loginOPS",
    component: () => import("@/pages/auth/LoginOPS.vue"),
    meta: { requiresUnAuth: true },
  },
  {
    path: "/login",
    name: "login",
    component: () => import("@/pages/auth/SdbCheckAuth.vue"),
    meta: { requiresUnAuth: true },
    props: (route) => ({ code: route.query.code, state: route.query.state }),
  },
  /* {
    path: "/login",
    name: "login",
    component: () => import("@/pages/auth/ManhosoAuth.vue"),
    meta: { requiresUnAuth: true },
    props: (route) => ({ code: route.query.code, state: route.query.state }),
  }, */
  {
    path: "/",
    component: () => import("@/pages/Menu/InitialMenu.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/MsF",
    name: "MEOSat MsF",
    component: () =>
      import("@/pages/Application/Embedded/GeoSat/GeoSat_MsF.vue"),
    meta: { requiresAuth: true, requiredDevice: "mobile" },
  },
  {
    path: "/MTV",
    name: "MEOSat TV Inst.",
    component: () =>
      import("@/pages/Application/Embedded/GeoSat/GeoSat_Tv.vue"),
    meta: { requiresAuth: true, requiredDevice: "mobile" },
  },
  {
    path: "/MTV",
    name: "MEOSat TV Acresc.",
    component: () =>
      import("@/pages/Application/Embedded/GeoSat/GeoSat_Tv.vue"),
    meta: { requiresAuth: true, requiredDevice: "mobile" },
  },
  {
    path: "/OnDemand",
    name: "MEOSat OnDemand",
    component: () =>
      import("@/pages/Application/Embedded/OnDemand/GeoSat_OnDemand.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/MRights",
    name: "MEOSat Direitos",
    component: () =>
      import("@/pages/Application/Embedded/GeoSat/GeoSat_Rights.vue"),
    meta: { requiresAuth: true, requiredDevice: "mobile" },
  },
  {
    path: "/StbSwap",
    name: "MEOSat Trocas",
    component: () =>
      import("@/pages/Application/Embedded/GeoSat/GeoSat_StbSwap.vue"),
    meta: { requiresAuth: true, requiredDevice: "mobile" },
  },
  {
    path: "/survey",
    name: "Survey",
    component: () =>
      import("@/pages/Application/Embedded/Survey/FieldSurvey.vue"),
    meta: { requiresAuth: true, requiredDevice: "mobile" },
    props: true,
  },
  {
    path: "/Notifications",
    component: () => import("@/pages/Notification/MainPage.vue"),
    meta: { requiresAuth: true },
    props: true,
  },
  { path: "/:notFound(.*)", component: () => import("@/pages/NotFound.vue") },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

const maintenanceRoutes = [
  "GeoSat MsF",
  "GeoSat TV",
  "GeoSat OnDemand",
  "GeoSat Rights",
  "GeoSat StbSwap",
  "Survey",
];

const isAdminUser = () => {
  const userDetails = store.getters.getUserDetailList || {};
  return Number(userDetails.usr_role_id) === 1;
};

const isMobileDevice = () => {
  if (typeof window === "undefined" || typeof navigator === "undefined") {
    return false;
  }

  const userAgent = navigator.userAgent || "";
  const mobileUserAgentRegex =
    /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;
  const hasMobileUserAgent = mobileUserAgentRegex.test(userAgent);
  const hasCoarsePointer = window.matchMedia?.("(pointer: coarse)")?.matches;
  const maxTouchPoints = navigator.maxTouchPoints || 0;

  return hasMobileUserAgent || Boolean(hasCoarsePointer && maxTouchPoints > 0);
};

router.beforeEach(function (to, from, next) {
  if (to.meta.requiresAuth && !store.getters.isAuthorized) {
    next("/loginOPS");
    return;
  }
  if (to.meta.requiresUnAuth && store.getters.isAuthorized) {
    next("/");
    return;
  }

  store.commit("SHOW_DEVICE_INCOMPATIBILITY_MODAL", false);
  store.commit("SET_DEVICE_INCOMPATIBILITY_APP_TYPE", null);

  const requiredDevice = to.meta.requiredDevice;
  if (requiredDevice && !isAdminUser()) {
    const mobileDevice = isMobileDevice();
    const isIncompatibleDevice =
      (requiredDevice === "mobile" && !mobileDevice) ||
      (requiredDevice === "desktop" && mobileDevice);

    if (isIncompatibleDevice) {
      store.commit(
        "SET_DEVICE_INCOMPATIBILITY_APP_TYPE",
        requiredDevice === "mobile" ? 2 : 1
      );
      store.commit("SHOW_DEVICE_INCOMPATIBILITY_MODAL", true);
      return next(false);
    }
  }

  if (maintenanceRoutes.includes(to.name)) {
    const app = store.getters.getUserApplicationList?.find(a => a.app_name === to.name);
    if (app && app.app_alerts_id === 1) {
      store.commit("SHOW_MAINTENANCE_MODAL", true);
      return next(false);
    }
  }
  next();
});

export default router;